import * as XLSX from "xlsx";
import { v4 as uuidv4 } from "uuid";
import { errorNotification } from "Components/MyNotification";

export const parseExcel = async (files) => {
  try {
    const fileArray = Array.from(files);

    const allResults = [];

    for (const file of fileArray) {
      const buffer = await file.arrayBuffer();

      const workbook = XLSX.read(buffer, {
        type: "array",
      });

      const sheet = workbook.Sheets[workbook.SheetNames[0]];

      const rows = XLSX.utils.sheet_to_json(sheet, {
        header: 1,
        defval: "",
      });

      if (!rows.length) {
        errorNotification("Файл порожній");
        return [];
      }

      const header = rows[0];

      if (
        header[0]?.toString().trim().toLowerCase() !== "матеріал" ||
        header[1]?.toString().trim().toLowerCase() !== "кількість" ||
        header[2]?.toString().trim().toLowerCase() !== "од"
      ) {
        errorNotification(
          "Невірний формат файлу. Очікуються колонки: Матеріал | Кількість | Од",
        );
        return [];
      }

      for (let i = 1; i < rows.length; i++) {
        const [nomenclature, count, unit] = rows[i];

        // кінець таблиці
        if (!nomenclature && !count && !unit) {
          break;
        }

        // неповний рядок
        if (!nomenclature || !count || !unit) {
          errorNotification(`Не заповнені всі поля в рядку ${i + 1}`);
          return [];
        }

        // Матеріал має бути текстом
        if (!isNaN(Number(nomenclature))) {
          errorNotification(
            `Рядок ${i + 1}: поле "Матеріал" повинно бути текстом`,
          );
          return [];
        }

        // Кількість має бути числом
        if (isNaN(Number(count))) {
          errorNotification(
            `Рядок ${i + 1}: поле "Кількість" повинно бути числом`,
          );
          return [];
        }

        // Од має бути текстом
        if (!isNaN(Number(unit))) {
          errorNotification(`Рядок ${i + 1}: поле "Од" повинно бути текстом`);
          return [];
        }

        allResults.push({
          id: uuidv4(),
          dateArrived: new Date().toISOString().slice(0, 10),
          nomenclature: String(nomenclature).trim(),
          count: Number(count),
          unit: String(unit).trim(),
          restCount: Number(count),
          usedCount: 0,
          workTypeTied: null,
        });
      }
    }

    return allResults;
  } catch (error) {
    errorNotification(
      "Не вдалося прочитати файл. Перевірте, що завантажено коректний Excel-файл.",
    );

    return [];
  }
};
